import clsx from 'clsx'
import { Package } from 'lucide-react'

interface Props {
  children: React.ReactNode
}

const AuthLayout: React.FC<Props> = ({ children }) => {

  return (
    <>
      <div
        className={clsx(
          'min-h-screen',
          'bg-gradient-to-br from-blue-50 via-white to-indigo-50',
          'flex items-center justify-center',
          'p-4'
        )}
      >
        <div className="w-full max-w-md">
          {/* 头部标题 */}
          <div className="text-center mb-8">
            <div
              className={clsx(
                'w-16 h-16 mx-auto mb-4',
                'bg-gradient-to-r from-blue-600 to-indigo-600',
                'rounded-2xl',
                'flex items-center justify-center',
                'shadow-lg'
              )}
            >
              <Package className="w-8 h-8 text-white" />
            </div>
            <h1 className={clsx('text-2xl font-bold text-gray-800', 'mb-2')}>
              保税仓储管理系统
            </h1>
            <p className="text-gray-600">让每一次点击，都值得期待</p>
          </div>

          {/* 主要内容卡片 */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 relative overflow-hidden">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export default AuthLayout
